import { bindDebriefChapterEditor, getDebriefChapterMarkdown, renderDebriefChapterEditor, renderDebriefMarkdown } from './debrief-chapter-editor.js'
import { bindDictationActivityDraftUi, renderDictationActivityDraftUi } from './dictation-activity-draft-renderer.js'
import { renderLucideIcon } from '../utils/lucide-icons.js'

function normalizeCapabilityBlockViewUi(result) {
  if (!result || typeof result !== 'object') return null

  var ui = String(result.type || '').toLowerCase() === 'capability-block-view'
    ? result
    : result.ui || result.view || result.display || null
  if (!ui || typeof ui !== 'object') return null
  if (String(ui.type || '').toLowerCase() !== 'capability-block-view') return null

  return {
    capability: ui.capability || '',
    profileKey: ui.profileKey || '',
    title: ui.title || '',
    subtitle: ui.subtitle || '',
    presentation: isObject(ui.presentation) ? ui.presentation : null,
    chapterEdits: Array.isArray(ui.chapterEdits) ? ui.chapterEdits : [],
    reviewIdentity: isObject(ui.reviewIdentity) ? ui.reviewIdentity : null,
    revision: isObject(ui.revision) ? ui.revision : null,
    cache: isObject(ui.cache) ? ui.cache : null,
    blocks: Array.isArray(ui.blocks) ? ui.blocks.filter(isObject) : [],
    summary: isObject(ui.summary) ? ui.summary : {}
  }
}

function bindCapabilityBlockViewUi(root, blockViewUi, handlers) {
  blockViewUi = indexDebriefActions(blockViewUi)
  bindDebriefNavigation(root)
  if (String(blockViewUi.capability).toUpperCase() === 'DEBRIEF' && root) handlers = bindDebriefChapterEditor(root, blockViewUi, handlers)
  bindHandoffActions(root, normalizeCapabilityActions(blockViewUi), handlers)
  bindDebriefActivityEditors(root, blockViewUi, handlers)
  bindDebriefOperations(root, blockViewUi, handlers)
  bindRefreshAction(root, blockViewUi, handlers)
}

function bindDebriefActivityEditors(root, blockViewUi, handlers) {
  if (!root || typeof root.querySelectorAll !== 'function' || String(blockViewUi.capability).toUpperCase() !== 'DEBRIEF') return
  var actions = normalizeCapabilityActions(blockViewUi)
  root.querySelectorAll('[data-debrief-activity-editor]').forEach(function (editor) {
    var action = actions[Number(editor.getAttribute('data-debrief-activity-index'))]
    if (!action) return
      bindDictationActivityDraftUi(editor, buildDebriefActivityDraftUi(action), {
      onConfirm: function (payload) {
        action.requestContext = Object.assign({}, action.requestContext || {}, {
          debriefActivityDraft: payload.activity || {}
        })
        var body = editor.parentNode && editor.parentNode.querySelector ? editor.parentNode.querySelector('.wc-debrief-operation-body') : null
        if (body && payload.activity) {
          var title = body.querySelector ? body.querySelector('strong') : null
          var detail = body.querySelector ? body.querySelector('span') : null
          if (title && payload.activity.title) title.textContent = payload.activity.title
          if (detail) detail.textContent = payload.activity.startAt ? 'Échéance : ' + payload.activity.startAt : 'Activité à créer'
        }
        editor.hidden = true
      }
    })
  })
  root.querySelectorAll('[data-debrief-activity-edit]').forEach(function (button) {
    button.addEventListener('click', function () {
      var editor = root.querySelector('[data-debrief-activity-editor][data-debrief-activity-index="' + button.getAttribute('data-debrief-activity-index') + '"]')
      if (editor) editor.hidden = !editor.hidden
    })
  })
}

function buildDebriefActivityDraftUi(action) {
  var suggestion = action.requestContext && action.requestContext.capabilitySuggestion || {}
  var candidate = suggestion.candidate || {}
  var candidateType = String(candidate.activityType || candidate.type || '').toLowerCase()
  if (!candidateType) candidateType = /réunion|reunion|rendez-vous|rendez vous/.test(String(action.label || '').toLowerCase()) ? 'meeting' : 'task'
  return {
    type: 'dictation-activity-draft',
    title: 'Modifier l’activité',
    message: action.reason || '',
    activity: {
      type: candidateType,
      startAt: candidate.startAt || candidate.deadline || null,
      endAt: candidate.endAt || null,
      title: action.label || suggestion.label || '',
      comment: action.reason || ''
    },
    typeOptions: [
      { value: 'task', label: 'Tâche' },
      { value: 'call', label: 'Appel' },
      { value: 'meeting', label: 'Rendez-vous' },
      { value: 'email', label: 'Email' }
    ],
    links: { entityId: null, contactId: null, dealId: null },
    associatedRecord: null,
    origins: { activity: { type: 'inferred', startAt: 'inferred', title: 'inferred', comment: 'inferred' }, links: {} },
    labels: { capability: '@Dictée', activityType: "Type d'activité", deadline: 'Échéance', title: 'Libellé', comment: 'Description', confirm: "Enregistrer l'activité", originExplicit: 'Fourni', originInferred: 'Déduit', originContext: 'Contexte' },
    nextStepKey: 'DictationExecute'
  }
}

function bindDebriefOperations(root, blockViewUi, handlers) {
  if (!root || typeof root.querySelector !== 'function' || String(blockViewUi.capability).toUpperCase() !== 'DEBRIEF' || !handlers || typeof handlers.onAction !== 'function') return
  var actions = normalizeCapabilityActions(blockViewUi)
  var checks = Array.from(root.querySelectorAll('[data-debrief-operation-check]'))
  var countNode = root.querySelector('[data-debrief-operation-count]')
  function selectedChecks() { return checks.filter(function (check) { return check.checked && !check.disabled }) }
  function updateCount() {
    if (countNode) countNode.textContent = String(selectedChecks().length)
    var submit = root.querySelector('[data-debrief-validate-operations]')
    if (submit) submit.disabled = selectedChecks().length === 0
  }
  checks.forEach(function (check) { check.addEventListener('change', updateCount) })
  updateCount()
  var submit = root.querySelector('[data-debrief-validate-operations]')
  if (!submit) return
  submit.addEventListener('click', function () {
    var selected = selectedChecks().map(function (check) {
      return actions[Number(check.getAttribute('data-debrief-operation-index'))]
    }).filter(Boolean)
    var updates = selected.map(function (action) { return action.requestContext && action.requestContext.debriefBusinessUpdateProposal }).filter(Boolean)
    var label = 'Valider les ' + selected.length + ' opérations'
    handlers.onAction({
      label: label,
      targetCapability: 'DICTATION',
      displayLabel: 'Activité',
      reason: 'Envoyer le plan Debrief sélectionné au backoffice',
      requestContext: {
        capabilitySuggestion: { originCapability: 'DEBRIEF', targetCapability: 'DICTATION', label: label },
        debriefOperationsPlan: {
          activityId: blockViewUi.reviewIdentity && blockViewUi.reviewIdentity.activityId || null,
          generatedAt: blockViewUi.reviewIdentity && blockViewUi.reviewIdentity.generatedAt || null,
          updates: updates,
          activities: selected.map(function (action) {
            return action.requestContext && action.requestContext.debriefActivityDraft
              ? Object.assign({ operationId: action.id || action.index || null }, action.requestContext.debriefActivityDraft)
              : null
          }).filter(Boolean),
          contacts: selectedChecks().filter(function (check) { return check.getAttribute('data-debrief-operation-kind') === 'contact' }).map(function (check) {
            var action = actions[Number(check.getAttribute('data-debrief-operation-index'))]
            var block = (blockViewUi.blocks || []).find(function (item) { return item.key === 'contact_creation_actions' })
            return (block && block.proposals || []).find(function (proposal) { return proposal.id === (action && action.proposalId) })
          }).filter(Boolean),
          operations: selected.map(function (action) {
            return {
              label: action.label,
              targetCapability: action.targetCapability,
              requestContext: action.requestContext
            }
          }),
          selectedOperationCount: selected.length
        }
      }
    })
  })
}

function renderCapabilityBlockViewUi(blockViewUi, translations) {
  blockViewUi = indexDebriefActions(blockViewUi)
  var labels = normalizeCapabilityBlockViewTranslations(translations)
  if (String(blockViewUi.capability).toUpperCase() === 'DEBRIEF' && !(blockViewUi.blocks || []).some(function (block) { return block.key === 'status' })) return renderDebriefReview(blockViewUi, labels)
  var summary = isObject(blockViewUi.summary) ? blockViewUi.summary : {}
  var blocks = Array.isArray(blockViewUi.blocks) ? blockViewUi.blocks : []
  var title = blockViewUi.title || resolveSummaryTitle(summary)

  return (
    '<div class="summary-ui wc-capability-block-ui" data-ds-view="capability-block-view" data-capability="' + escapeHtml(blockViewUi.capability) + '" data-profile-key="' + escapeHtml(blockViewUi.profileKey) + '">' +
      renderBlocksWithTitle(blocks, blockViewUi, labels, title) +
    '</div>'
  )
}

// Index across all Debrief groups so saving cannot replace a Plume/Dictée action.
function indexDebriefActions(ui) {
  if (String(ui.capability).toUpperCase() !== 'DEBRIEF') return ui
  var index = 0
  var blocks = (ui.blocks || []).map(function (block) {
    if (block.type !== 'handoff-actions') return block
    return Object.assign({}, block, { content: normalizeActions(block.content).map(function (action) {
      return Object.assign({}, action, { index: index++ })
      }) })
  })
  if (!blocks.some(function (block) { return block.key === 'communication' }) && hasUsableDebriefForCommunication(ui)) {
    blocks.push({
      key: 'communication',
      type: 'handoff-actions',
      title: 'Communication',
      content: [{
        label: 'Rédiger avec Plume',
        targetCapability: 'WRITE_EMAIL',
        displayLabel: 'Plume',
        icon: 'feather',
        reason: 'Préparer un email de suivi à partir du bilan Debrief',
        index: index++,
        requestContext: {
          capabilitySuggestion: {
            originCapability: 'DEBRIEF',
            targetCapability: 'WRITE_EMAIL'
          }
        }
      }]
    })
  }
  var contacts = blocks.find(function (block) { return block.key === 'contact_creation_actions' })
  if (contacts && !blocks.some(function (block) { return block.key === 'contact_creation_handoffs' })) {
    blocks.push({
      key: 'contact_creation_handoffs',
      type: 'handoff-actions',
      title: 'Modifier un contact',
      content: (contacts.proposals || []).map(function (proposal) {
        var action = proposal && proposal.action
        return {
          label: 'Modifier ' + String(proposal && proposal.detected && proposal.detected.fullName || 'le contact'),
          targetCapability: action ? 'DEBRIEF' : 'NONE',
          displayLabel: 'Contact',
          icon: 'pencil',
          reason: 'Compléter ou modifier la fiche contact avant validation',
          requestContext: action ? Object.assign({}, action.requestContext || {}, { stepKey: action.stepKey }) : {},
          proposalId: proposal && proposal.id
        }
      }).map(function (action) { return Object.assign({}, action, { index: index++ }) })
    })
  }
  return Object.assign({}, ui, { blocks: blocks })
}

function hasUsableDebriefForCommunication(ui) {
  var reviewIdentity = ui && ui.reviewIdentity
  if (!reviewIdentity || !String(reviewIdentity.activityId || '').trim()) return false
  return (ui.blocks || []).some(function (block) {
    if (!block || ['capability', 'save_review'].includes(block.key)) return false
    if (typeof block.content === 'string') return Boolean(block.content.trim())
    return Array.isArray(block.content) && block.content.length > 0
  })
}

var debriefViewSequence = 0
var debriefChapters = [
  ['synthesis', 'Synthèse générale', ['summary']],
  ['context', 'Contexte et besoins', ['important_facts']],
  ['decisions', 'Décisions et évolutions', ['changes']],
  ['vigilance', 'Points de vigilance', ['uncertainties', 'deductions']],
  ['commitments', 'Engagements et responsables', ['commitments']],
  ['next_actions', 'Prochaines actions', ['next_actions']],
  ['briefing', 'Écarts avec le Briefing', ['briefing_comparison']]
]

function renderDebriefReview(ui, labels) {
  var id = 'wc-debrief-review-' + (++debriefViewSequence)
  var blocks = ui.blocks || []
  var presentation = ui.presentation || {}
  var summaryBlock = blocks.find(function (block) { return block.key === 'summary' })
  var summary = presentation.summary || (summaryBlock && typeof summaryBlock.content === 'string' ? summaryBlock.content : '')
  var chapters = debriefChapters.map(function (entry) {
    var chapter = (presentation.chapters || []).find(function (item) { return item.key === entry[0] })
    var body = chapter && Array.isArray(chapter.sections) ? chapter.sections.map(function (section) {
      return '<h4>' + escapeHtml(section.title) + '</h4>' + (section.paragraphs || []).map(function (text) {
        return '<p>' + escapeDisplayText(text) + '</p>' + renderDebriefParagraphCitations(text, blocks, entry[2])
      }).join('')
    }).join('') : entry[2].map(function (key) {
      var block = blocks.find(function (item) { return item.key === key })
      if (!block) return ''
      var items = Array.isArray(block.content) ? block.content : [block.content]
      return '<h4>' + escapeHtml(block.title) + '</h4>' + items.map(function (item) {
        return '<p>' + escapeDisplayText(renderContentText(item)) + '</p>' + renderNumberedItemCitations(item && item.citations)
      }).join('')
    }).join('')
    var markdown = getDebriefChapterMarkdown(ui, entry[0], entry[2])
    if ((ui.chapterEdits || []).some(function (edit) { return edit.key === entry[0] })) body = renderDebriefMarkdown(markdown)
    return { key: entry[0], title: entry[1], markdown: markdown, body: body || '<p>Aucune information disponible pour ce chapitre.</p>' }
  })
  var followupKeys = ['next_action_handoffs', 'activity_creation_actions', 'business_update_proposals', 'business_update_handoffs']
  var followups = blocks.filter(function (block) { return followupKeys.includes(block.key) })
  var communication = blocks.find(function (block) { return block.key === 'communication' })
  var updateActions = blocks.find(function (block) { return block.key === 'business_update_edit_actions' })
  var nextActions = blocks.find(function (block) { return block.key === 'activity_creation_actions' || block.key === 'next_action_handoffs' })
  var activityActions = nextActions && Object.assign({}, nextActions, { content: (nextActions.content || []).filter(function (action) { return String(action.targetCapability || '').toUpperCase() === 'DICTATION' }) })
  var contactActions = blocks.find(function (block) { return block.key === 'contact_creation_handoffs' })
  var contactProposals = blocks.find(function (block) { return block.key === 'contact_creation_actions' })
  var save = blocks.find(function (block) { return block.key === 'save_review' })
  var updateProposalBlock = blocks.find(function (block) { return block.key === 'business_update_proposals' })
  var suiteCount = (updateProposalBlock && Array.isArray(updateProposalBlock.content) ? updateProposalBlock.content.length : (updateActions && Array.isArray(updateActions.content) ? updateActions.content.length : 0)) +
    (nextActions && Array.isArray(nextActions.content) ? nextActions.content.filter(function (action) { return String(action.targetCapability || '').toUpperCase() === 'DICTATION' }).length : 0) +
    (contactProposals && Array.isArray(contactProposals.proposals) ? contactProposals.proposals.length : 0)
  // Update proposals and activities are selected by default; contacts require
  // explicit validation because their card may still be incomplete.
  var initialOperationCount = (updateActions && Array.isArray(updateActions.content) ? updateActions.content.length : 0) +
    (nextActions && Array.isArray(nextActions.content) ? nextActions.content.filter(function (action) { return String(action.targetCapability || '').toUpperCase() === 'DICTATION' }).length : 0)
  if (!initialOperationCount && suiteCount && !updateActions && !nextActions) initialOperationCount = suiteCount
  function tab(key, title, selected) {
    return '<button type="button" role="tab" id="' + id + '-tab-' + key + '" aria-controls="' + id + '-panel-' + key + '" aria-selected="' + selected + '" tabindex="' + (selected ? '0' : '-1') + '" data-debrief-tab="' + key + '">' + title + '</button>'
  }
  return '<div class="summary-ui wc-capability-block-ui wc-debrief-review" data-capability="DEBRIEF">' +
    '<header class="wc-debrief-review-header"><div class="wc-debrief-review-eyebrow">Débrief du rendez-vous' + (ui.subtitle ? ' · ' + escapeHtml(ui.subtitle) : '') + '</div>' +
    '<h3>' + escapeHtml(presentation.title || ui.subtitle || 'Bilan du rendez-vous') + '</h3>' +
    (summary ? '<p>' + escapeDisplayText(summary) + '</p>' : '') +
    (presentation.focus ? '<aside class="wc-debrief-review-focus"><strong>À retenir</strong><p>' + escapeDisplayText(presentation.focus) + '</p></aside>' : '') +
    renderCacheMeta(ui, labels) + '</header>' +
    '<div class="wc-debrief-review-workspace"><div class="wc-debrief-review-tabs" role="tablist" aria-label="Débrief du rendez-vous">' + tab('bilan', 'Bilan du rendez-vous', true) + tab('suites', 'Suites à traiter (' + suiteCount + ')', false) + '</div>' +
    '<section id="' + id + '-panel-bilan" role="tabpanel" aria-labelledby="' + id + '-tab-bilan" data-debrief-panel="bilan">' +
    '<div class="wc-debrief-review-bilan"><nav class="wc-debrief-review-nav" aria-label="Chapitres du bilan">' + chapters.map(function (chapter, index) {
      return '<button type="button" data-debrief-chapter="' + chapter.key + '" aria-controls="' + id + '-chapter-' + chapter.key + '" aria-current="' + (index === 0 ? 'true' : 'false') + '">' + chapter.title + '</button>'
    }).join('') + '</nav><div class="wc-debrief-review-content">' + chapters.map(function (chapter, index) {
      return '<article id="' + id + '-chapter-' + chapter.key + '" data-debrief-chapter-panel="' + chapter.key + '"' + (index ? ' hidden' : '') + '>' + renderDebriefChapterEditor(chapter, id + '-editor-' + chapter.key, escapeHtml) + '</article>'
    }).join('') + '</div></div>' + (save ? '<footer class="wc-debrief-review-footer"><p class="sectionhelp" data-debrief-edit-status role="status" aria-live="polite"></p>' + renderDebriefSaveButton(save, labels) + '</footer>' : '') + '</section>' +
    '<section id="' + id + '-panel-suites" role="tabpanel" aria-labelledby="' + id + '-tab-suites" data-debrief-panel="suites" hidden><div class="wc-debrief-review-followups">' +
    renderDebriefProposalGroup(updateActions, 'MISES À JOUR', labels, 'Aucune mise à jour détectée') +
    renderDebriefContactGroup(blocks.find(function (block) { return block.key === 'contact_creation_actions' }), contactActions, labels) +
    renderDebriefProposalGroup(activityActions, 'ACTIVITÉS À CRÉER', labels) +
    (followups.filter(function (block) { return block.key !== 'business_update_proposals' && block.key !== 'business_update_handoffs' && block.key !== 'activity_creation_actions' && block.key !== 'next_action_handoffs' }).length
      ? followups.filter(function (block) { return block.key !== 'business_update_proposals' && block.key !== 'business_update_handoffs' && block.key !== 'activity_creation_actions' && block.key !== 'next_action_handoffs' }).map(function (block) { return renderBlock(block, ui, labels) }).join('')
      : '') +
    renderDebriefCommunication(communication, labels) +
    renderDebriefOperationsFooter(initialOperationCount, labels) +
    '</div></section></div></div>'
}

function renderDebriefProposalGroup(block, title, labels, emptyMessage) {
  if (!block || !Array.isArray(block.content) || !block.content.length) {
    if (!emptyMessage) return ''
    return '<section class="wc-debrief-operation-group"><h3 class="wc-debrief-operation-group-title">' + escapeHtml(title) + '</h3><p class="wc-debrief-operation-empty">' + escapeHtml(emptyMessage) + '</p></section>'
  }
  return '<section class="wc-debrief-operation-group"><h3 class="wc-debrief-operation-group-title">' + escapeHtml(title) + ' · ' + block.content.length + '</h3><div class="wc-debrief-operation-list">' + block.content.map(function (action) {
    var normalized = normalizeAction(action)
    var proposal = action.requestContext && action.requestContext.debriefBusinessUpdateProposal || {}
    var isNextAction = !proposal.id
    var editor = isNextAction ? '<div class="wc-debrief-activity-editor" data-debrief-activity-editor data-debrief-activity-index="' + escapeHtml(normalized.index) + '" hidden>' + renderDictationActivityDraftUi(buildDebriefActivityDraftUi(normalized)) + '</div>' : ''
    var current = proposal.currentValue || (isNextAction ? 'Nouvelle opération proposée' : 'Aucune valeur précédente renseignée')
    var proposed = proposal.proposedValue || (isNextAction ? normalized.reason || 'À préciser' : 'Valeur à préciser')
    var objectChip = isNextAction ? '' : '<span class="wc-debrief-operation-object-chip">' + escapeHtml(resolveDebriefObjectChip(proposal.objectType)) + '</span>'
    var editButton = isNextAction ? '<button type="button" class="wc-debrief-operation-edit" data-debrief-activity-edit data-debrief-activity-index="' + escapeHtml(normalized.index) + '">' + renderLucideIcon('pencil', { size: 20 }) + 'Modifier</button>' : ''
    return '<article class="wc-debrief-operation" data-debrief-operation-id="' + escapeHtml(proposal.id || normalized.index) + '"><input class="wc-debrief-operation-check" type="checkbox" checked data-debrief-operation-check data-debrief-operation-kind="' + (isNextAction ? 'activity' : 'update') + '" data-debrief-operation-index="' + escapeHtml(normalized.index) + '" aria-label="Sélectionner ' + escapeHtml(proposal.fieldLabel || normalized.label) + '"><div class="wc-debrief-operation-body"><strong>' + escapeHtml(proposal.fieldLabel || normalized.label) + '</strong>' + objectChip + '<span class="wc-debrief-operation-current"><b>Valeur actuelle :</b> ' + escapeHtml(current) + '</span><small class="wc-debrief-operation-proposed"><b>Nouvelle valeur :</b> ' + escapeHtml(proposed) + '</small></div>' + editButton + editor + '</article>'
  }).join('') + '</div></section>'
}

function resolveDebriefObjectChip(objectType) {
  var labels = { account: 'Compte', company: 'Compte', contact: 'Contact', opportunity: 'Opportunité', deal: 'Opportunité', activity: 'Activité', meeting: 'Bilan' }
  return labels[String(objectType || '').toLowerCase()] || 'Bilan'
}

function renderDebriefContactGroup(block, actionsBlock, labels) {
  if (!block || !Array.isArray(block.proposals) || !block.proposals.length) return ''
  var actions = actionsBlock && Array.isArray(actionsBlock.content) ? actionsBlock.content : []
  return '<section class="wc-debrief-operation-group"><h3 class="wc-debrief-operation-group-title">CONTACTS À CRÉER · ' + block.proposals.length + '</h3><div class="wc-debrief-operation-list">' + block.proposals.map(function (proposal, index) {
    var action = actions[index] || {}
    var normalized = normalizeAction(action)
    var detected = proposal.detected || {}
    var name = firstContactDisplayValue([detected.fullName, [detected.firstName, detected.lastName].filter(Boolean).join(' ')]) || 'Contact à compléter'
    var detail = [proposal.entityLabel || detected.company, detected.email || detected.role || detected.function].map(function (value) { return firstContactDisplayValue([value]) }).filter(Boolean).join(' · ')
    var missing = proposal.status === 'incomplete' || proposal.status === 'blocked_no_entity' || proposal.status === 'probable_duplicate'
    var canEdit = normalized.targetCapability !== 'NONE'
    return '<article class="wc-debrief-operation" data-debrief-operation-id="' + escapeHtml(proposal.id || index) + '"><input class="wc-debrief-operation-check" type="checkbox" ' + (canEdit ? '' : 'disabled ') + 'data-debrief-operation-check data-debrief-operation-kind="contact" data-debrief-operation-index="' + escapeHtml(normalized.index) + '" aria-label="Sélectionner ' + escapeHtml(name) + '"><div class="wc-debrief-operation-body"><strong>' + escapeHtml(name) + '</strong><span>' + escapeHtml(detail || 'Informations à compléter') + '</span></div>' + (missing ? '<span class="wc-debrief-operation-badge">À compléter</span>' : '') + (canEdit ? '<button type="button" class="wc-debrief-operation-edit" data-capability-action-index="' + escapeHtml(normalized.index) + '">' + renderLucideIcon('pencil', { size: 20 }) + 'Modifier</button>' : '') + '</article>'
  }).join('') + '</div></section>'
}

function firstContactDisplayValue(values) {
  return (values || []).map(function (value) { return String(value || '').trim() }).find(function (value) {
    return value && !/^(?:[a-f0-9]{24}|[0-9a-f]{8}-[0-9a-f-]{27,}|(?:contact|entity|company|person)[_:-][a-z0-9_-]+)$/i.test(value)
  }) || ''
}

function renderDebriefOperationsFooter(count, labels) {
  if (!count) return ''
  return '<div class="wc-debrief-operations-footer"><button type="button" class="wc-debrief-operations-submit" data-debrief-validate-operations>Valider les <span data-debrief-operation-count>' + count + '</span> opérations</button></div>'
}

function renderDebriefSaveButton(block, labels) {
  var action = normalizeActions(block.content)[0]
  if (!action) return ''
  return '<div class="wc-debrief-save-footer"><button type="button" class="capability-action wc-debrief-save-button" data-capability-action-index="' + escapeHtml(action.index) + '" data-target-capability="' + escapeHtml(action.targetCapability) + '">' + renderLucideIcon('save', { size: 20 }) + '<span>' + escapeHtml(action.label || 'Enregistrer le bilan') + '</span></button></div>'
}

function renderDebriefCommunication(block, labels) {
  var action = block && normalizeActions(block.content)[0]
  if (!action) return ''
  return '<section class="wc-debrief-communication" aria-labelledby="wc-debrief-communication-title"><div class="wc-debrief-communication-copy"><div class="wc-debrief-communication-title" id="wc-debrief-communication-title"><span class="wc-debrief-communication-icon">' + renderLucideIcon('feather', { size: 20 }) + '</span><strong>Communication</strong></div><p>Prépare un email de suivi à partir du bilan et des engagements du rendez-vous.</p></div><button type="button" class="capability-action wc-debrief-plume-button" data-capability-action-index="' + escapeHtml(action.index) + '" data-target-capability="WRITE_EMAIL">' + renderLucideIcon('feather', { size: 20 }) + '<span>Rédiger avec Plume</span></button></section>'
}

function renderDebriefParagraphCitations(text, blocks, blockKeys) {
  var normalizedText = normalizeDisplayText(text).toLowerCase()
  var citations = []
  ;(blockKeys || []).forEach(function (key) {
    var block = (blocks || []).find(function (item) { return item.key === key })
    if (!block) return
    var citationMap = isObject(block.citationsByItem) ? block.citationsByItem : {}
    Object.keys(citationMap).forEach(function (itemText) {
      var normalizedItem = normalizeDisplayText(itemText).toLowerCase()
      if (!normalizedItem || !(normalizedText.includes(normalizedItem) || normalizedItem.includes(normalizedText))) return
      citations = citations.concat(normalizeCitations(citationMap[itemText]))
    })
    var content = Array.isArray(block.content) ? block.content : [block.content]
    content.forEach(function (item) {
      var label = isObject(item) ? String(item.label || item.text || '') : ''
      if (!label) return
      var normalizedLabel = normalizeDisplayText(label).toLowerCase()
      if (normalizedText.includes(normalizedLabel) || normalizedLabel.includes(normalizedText)) {
        citations = citations.concat(normalizeCitations(item.citations))
      }
    })
  })
  var seen = {}
  citations = citations.filter(function (citation) {
    var key = String(citation.excerpt || '')
    if (!key || seen[key]) return false
    seen[key] = true
    return true
  })
  return renderNumberedItemCitations(citations)
}

function bindDebriefNavigation(root) {
  if (!root) return
  var tabs = Array.from(root.querySelectorAll('[data-debrief-tab]'))
  function selectTab(button) {
    tabs.forEach(function (tab) {
      var selected = tab === button
      tab.setAttribute('aria-selected', String(selected))
      tab.tabIndex = selected ? 0 : -1
    })
    root.querySelectorAll('[data-debrief-panel]').forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-debrief-panel') !== button.getAttribute('data-debrief-tab')
    })
  }
  tabs.forEach(function (button, index) {
    button.addEventListener('click', function () { selectTab(button) })
    button.addEventListener('keydown', function (event) {
      var next = event.key === 'ArrowRight' ? (index + 1) % tabs.length : event.key === 'ArrowLeft' ? (index + tabs.length - 1) % tabs.length : event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : null
      if (next === null) return
      event.preventDefault()
      selectTab(tabs[next])
      tabs[next].focus()
    })
  })
  root.querySelectorAll('[data-debrief-chapter]').forEach(function (button) {
    button.addEventListener('click', function () {
      var key = button.getAttribute('data-debrief-chapter')
      root.querySelectorAll('[data-debrief-chapter]').forEach(function (item) { item.setAttribute('aria-current', String(item === button)) })
      root.querySelectorAll('[data-debrief-chapter-panel]').forEach(function (panel) { panel.hidden = panel.getAttribute('data-debrief-chapter-panel') !== key })
    })
  })
}

function renderBlocksWithTitle(blocks, blockViewUi, labels, title) {
  var revisionHtml = renderRevisionBadge(blockViewUi, labels)
  var cacheHtml = renderCacheMeta(blockViewUi, labels)
  var titleHtml = renderCapabilityBlockHeading(title, revisionHtml, cacheHtml)
  var titleRendered = false
  var html = blocks.map(function (block, index) {
    var rendered = renderBlock(block, blockViewUi, labels)
    if (!titleHtml || titleRendered) return rendered
    if (String(block.type || '').toLowerCase() === 'capability-bar') {
      titleRendered = true
      return rendered + titleHtml
    }
    if (index === 0) {
      titleRendered = true
      return titleHtml + rendered
    }
    return rendered
  }).join('')

  return titleHtml && !titleRendered ? titleHtml + html : (revisionHtml || cacheHtml) && !titleHtml ? revisionHtml + cacheHtml + html : html
}

function renderCapabilityBlockHeading(title, revisionHtml, cacheHtml) {
  if (!title) return ''
  return (
    '<div class="wc-capability-block-heading">' +
      '<h3 class="summary-title wc-capability-block-title">' + escapeHtml(title) + '</h3>' +
      (revisionHtml || cacheHtml ? '<div class="wc-capability-block-heading-meta">' + revisionHtml + cacheHtml + '</div>' : '') +
    '</div>'
  )
}

function renderRevisionBadge(blockViewUi, labels) {
  var revision = isObject(blockViewUi.revision) ? blockViewUi.revision : null
  if (!revision) return ''
  var label = revision.label || labels.revisionLabel || 'Version mise à jour'
  return '<div class="wc-capability-block-revision" data-ds-state="revision">' + escapeHtml(label) + '</div>'
}

function renderCacheMeta(blockViewUi, labels) {
  var cache = isObject(blockViewUi.cache) ? blockViewUi.cache : null
  if (!cache || !cache.generatedAt) return ''
  var generatedAt = formatGeneratedAt(cache.generatedAt)
  if (!generatedAt) return ''
  var capability = String(blockViewUi.capability || '').toUpperCase()
  var refreshable = cache.refreshable !== false && (capability === 'BRIEFING' || capability === 'DEBRIEF')
  var refreshKey = capability.toLowerCase()
  var refreshLabel = capability === 'DEBRIEF' ? labels.refreshDebrief : labels.refreshBriefing
  var button = refreshable
    ? '<button class="wc-capability-block-refresh" type="button" data-capability-refresh="' + escapeHtml(refreshKey) + '" aria-label="' + escapeHtml(refreshLabel) + '" title="' + escapeHtml(refreshLabel) + '">' + renderLucideIcon('refreshCcw', { size: 20 }) + '</button>'
    : ''
  return (
    '<div class="wc-capability-block-cache" data-cache-status="' + escapeHtml(cache.status || '') + '">' +
      '<span>' + escapeHtml(labels.generatedAt) + ' ' + escapeHtml(generatedAt) + '</span>' +
      button +
    '</div>'
  )
}

function formatGeneratedAt(value) {
  var date = new Date(value)
  if (Number.isNaN(date.getTime())) return String(value || '').trim()
  try {
    return date.toLocaleString('fr-FR', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    })
  } catch (error) {
    return date.toISOString()
  }
}

function bindRefreshAction(root, blockViewUi, handlers) {
  if (!root || !handlers || typeof handlers.onRefresh !== 'function') return

  root.querySelectorAll('[data-capability-refresh]').forEach(function (button) {
    button.addEventListener('click', function () {
      handlers.onRefresh(blockViewUi, button)
    })
  })
}

function renderBlock(block, blockViewUi, labels) {
  if (!block || typeof block !== 'object') return ''
  var type = String(block.type || '').toLowerCase()

  if (type === 'capability-bar') return renderCapabilityBar(block, blockViewUi, labels)
  if (type === 'briefing-intro') return renderBriefingIntro(block, labels)
  if (type === 'briefing-nav') return renderBriefingNav(block, labels)
  if (type === 'summary-card') return renderSummaryCard(block, labels)
  if (type === 'timeline-list') return renderTimelineList(block, labels)
  if (type === 'numbered-list') return renderNumberedList(block, labels)
  if (type === 'special-block-grid') return renderSpecialBlockGrid(block, labels)
  if (type === 'handoff-actions') return renderHandoffActions(block, labels)
  if (type === 'evidence-details') return renderEvidenceDetails(block, labels)

  return renderGenericBlock(block, labels)
}

function renderCapabilityBar(block, blockViewUi, labels) {
  var confidence = normalizeConfidence(resolveReliabilityValue(block, blockViewUi), labels)
  var title = block.title || labels.defaultCapabilityTitle
  var icon = normalizeIconName(block.icon) || 'blocks'

  return (
    '<section class="capability wc-capability-block-capability" data-ds-block="capability-bar" data-block-type="capability-bar">' +
      '<div class="capability-name wc-capability-block-capability-name">' +
        renderLucideIcon(icon, { class: 'wc-capability-block-icon' }) +
        '<span>' + escapeHtml(title) + '</span>' +
      '</div>' +
      '<div class="capability-meta wc-capability-block-reliability">' +
        escapeHtml(labels.reliability) + ' · ' + confidence.percent + ' % · ' + escapeHtml(capitalize(confidence.label)) +
      '</div>' +
    '</section>'
  )
}

function renderSummaryCard(block, labels) {
  var content = block.content
  var summary = isObject(content) ? content : {}
  var text = summary.executiveSummary || (typeof content === 'string' ? content : '')
  var cardTitle = String(summary.title || '').trim()
  var icon = normalizeIconName(block.icon)
  var iconHtml = icon
    ? '<span class="wc-capability-block-summary-icon">' + renderLucideIcon(icon, { size: 20 }) + '</span>'
    : ''
  var body = '<div class="summary-card wc-capability-block-summary-card' + (icon ? ' has-icon' : '') + '" data-ds-block="summary-card" data-block-type="summary-card">' +
    iconHtml +
    '<div>' +
      (cardTitle ? '<strong class="wc-capability-block-summary-title">' + escapeHtml(cardTitle) + '</strong>' : '') +
      '<div>' + escapeDisplayText(text || labels.noSummary) + '</div>' +
    '</div>' +
  '</div>'
  return renderSection(block.title || labels.executiveSummary, body, 'summary-card', block.key)
}

function renderBriefingIntro(block, labels) {
  var content = isObject(block.content) ? block.content : {}
  var cards = Array.isArray(content.cards) ? content.cards.filter(isObject).slice(0, 3) : []
  var outcome = isObject(content.outcome) ? content.outcome : {}
  var headline = String(content.headline || block.title || labels.briefingIntroTitle).trim()
  var rawLead = String(content.lead || '').trim()
  var lead = isDistinctBriefingIntroText(headline, rawLead) ? rawLead : ''
  var outcomeText = String(outcome.text || '').trim()

  if (!headline && !lead && !cards.length && !outcomeText) return ''

  return (
    '<section class="wc-capability-block-brief-intro" data-ds-section="briefing-intro" data-block-type="briefing-intro">' +
      '<div class="wc-capability-block-brief-top">' +
        '<div>' +
          '<div class="wc-capability-block-brief-eyebrow">' + escapeHtml(labels.briefingIntroTitle) + '</div>' +
          (headline ? '<h3>' + escapeHtml(headline) + '</h3>' : '') +
          (lead ? '<p>' + escapeDisplayText(lead) + '</p>' : '') +
        '</div>' +
        '<span class="wc-capability-block-brief-mark">' + renderLucideIcon('sparkles', { size: 20 }) + escapeHtml(labels.aiSynthesis) + '</span>' +
      '</div>' +
      (cards.length
        ? '<div class="wc-capability-block-brief-cards">' + cards.map(renderBriefingIntroCard).join('') + '</div>'
        : '') +
      (outcomeText
        ? '<div class="wc-capability-block-brief-outcome">' +
            '<span class="wc-capability-block-brief-outcome-icon">' + renderLucideIcon('target', { size: 20 }) + '</span>' +
            '<div><div class="wc-capability-block-brief-eyebrow wc-capability-block-brief-outcome-label">' + escapeHtml(outcome.label || labels.exitObjective) + '</div>' +
            '<strong>' + escapeDisplayText(outcomeText) + '</strong></div>' +
          '</div>'
        : '') +
    '</section>'
  )
}

function renderBriefingIntroCard(card) {
  var label = String(card.label || '').trim()
  var title = String(card.title || '').trim()
  var rawText = String(card.text || '').trim()
  var text = isDistinctBriefingIntroText(title, rawText) ? rawText : ''
  return (
    '<div class="wc-capability-block-brief-mini">' +
      (label ? '<div class="wc-capability-block-brief-mini-label">' + escapeHtml(label) + '</div>' : '') +
      (title ? '<strong>' + escapeHtml(title) + '</strong>' : '') +
      (text ? '<p>' + escapeDisplayText(text) + '</p>' : '') +
    '</div>'
  )
}

function isDistinctBriefingIntroText(title, text) {
  var normalizedTitle = normalizeDisplayText(title).toLowerCase()
  var normalizedText = normalizeDisplayText(text).toLowerCase()
  return Boolean(normalizedText) && normalizedTitle !== normalizedText
}

function renderBriefingNav(block, labels) {
  var items = Array.isArray(block.content) ? block.content.filter(isObject) : []
  if (!items.length) return ''
  return (
    '<nav class="wc-capability-block-brief-nav" aria-label="' + escapeHtml(labels.exploreBriefing) + '" data-ds-block="briefing-nav" data-block-type="briefing-nav">' +
      '<span>' + escapeHtml(labels.exploreBriefing) + '</span>' +
      items.map(function (item) {
        var label = String(item.label || '').trim()
        var targetKey = String(item.targetKey || '').trim()
        if (!label || !targetKey) return ''
        return '<a href="#briefing-section-' + escapeHtml(targetKey) + '">' + escapeHtml(label) + '</a>'
      }).join('') +
    '</nav>'
  )
}

function renderNumberedList(block, labels) {
  var items = normalizeNumberedItems(block.content)
  if (!items.length) return ''
  return renderSection(block.title || labels.keyPoints, renderNumberedRows(items), 'numbered-list', block.key)
}

function renderTimelineList(block, labels) {
  var model = normalizeTimelineModel(block.content, labels)
  var items = model.items
  if (!items.length) return ''
  return renderSection(block.title || labels.recentHistory, renderTimelinePanel(model, labels, block.key), 'timeline-list', block.key)
}

function renderTimelinePanel(model, labels, blockKey) {
  var controlsName = 'briefing-history-filter-' + String(blockKey || 'timeline').replace(/[^a-z0-9_-]/gi, '-')
  return (
    '<div class="wc-capability-block-history" data-ds-block="timeline-list" data-block-type="timeline-list">' +
      '<div class="wc-capability-block-history-summary">' +
        '<div class="wc-capability-block-history-eyebrow">' + escapeHtml(labels.keyTakeaways) + '</div>' +
        '<p>' + escapeDisplayText(model.summary) + '</p>' +
      '</div>' +
      '<div class="wc-capability-block-history-toolbar">' +
        '<div><strong>' + escapeHtml(labels.exchangeTimeline) + '</strong>' +
        '<span>' + escapeHtml(labels.exchangeTimelineHint) + '</span></div>' +
        renderTimelineFilters(model.filters, controlsName, labels) +
      '</div>' +
      renderTimelineRows(model.items, labels) +
    '</div>'
  )
}

function renderTimelineFilters(filters, controlsName, labels) {
  if (!filters.length) return ''
  return '<div class="wc-capability-block-history-filter-set" role="group" aria-label="' + escapeHtml(labels.filterHistory) + '">' +
    filters.map(function (filter, index) {
      var id = controlsName + '-' + filter.key
      var checked = index === 0 ? ' checked' : ''
      return '<input type="radio" id="' + escapeHtml(id) + '" name="' + escapeHtml(controlsName) + '" value="' + escapeHtml(filter.key) + '"' + checked + '>' +
        '<label for="' + escapeHtml(id) + '">' + escapeHtml(filter.label) + ' <span>(' + escapeHtml(String(filter.count)) + ')</span></label>'
    }).join('') +
  '</div>'
}

function renderTimelineRows(items, labels) {
  return (
    '<div class="wc-capability-block-timeline">' +
      items.map(function (item) {
        var date = formatTimelineDate(item.date)
        var details = item.summary && item.summary !== item.title
          ? '<div class="wc-capability-block-timeline-summary" title="' + escapeHtml(normalizeDisplayText(item.summary)) + '">' + escapeTimelineText(item.summary) + '</div>'
          : ''

        return (
          '<article class="wc-capability-block-timeline-item" data-timeline-item="' + escapeHtml(item.id) + '" data-history-category="' + escapeHtml(item.category) + '">' +
            '<div class="wc-capability-block-timeline-dot" aria-hidden="true"></div>' +
            '<div class="wc-capability-block-timeline-copy">' +
              '<div class="wc-capability-block-timeline-top">' +
                '<div>' +
                  (date ? '<div class="wc-capability-block-timeline-date">' + escapeTimelineText(date) + '</div>' : '') +
                  '<div class="wc-capability-block-timeline-title" title="' + escapeHtml(normalizeDisplayText(item.title || item.displayText)) + '">' + escapeTimelineText(item.title || item.displayText) + '</div>' +
                '</div>' +
                '<span class="wc-capability-block-timeline-tag">' + escapeTimelineText(item.categoryLabel) + '</span>' +
              '</div>' +
              details +
            '</div>' +
          '</article>'
        )
      }).join('') +
    '</div>'
  )
}

function renderSpecialBlockGrid(block, labels) {
  var columns = normalizeColumns(block.columns)
  if (!columns.length) return ''
  return (
    '<section class="summary-section wc-capability-block-section" id="briefing-section-' + escapeHtml(block.key || '') + '" data-ds-section="special-block-grid">' +
      '<div class="section-kicker wc-capability-block-section-title">' + escapeHtml(block.title || labels.risksAndOpportunities) + '</div>' +
      '<div class="special-grid wc-capability-block-risk-levers" data-ds-block="special-block-grid" data-block-type="special-block-grid">' +
        columns.map(function (column) {
          return renderSpecialBlockColumn(column, labels)
        }).join('') +
      '</div>' +
    '</section>'
  )
}

function renderSpecialBlockColumn(column, labels) {
  var kind = resolveSpecialBlockKind(column.key)
  var items = normalizeSpecialBlockItems(column.content)
  var fallback = kind === 'warning' ? labels.noRisk : labels.noOpportunity
  var title = column.title || resolveColumnTitle(column.key, labels)
  var icon = resolveSpecialBlockIcon(column.key)
  var visibleItems = items.length ? items : [{ label: fallback }]

  return (
    '<div class="special-block ' + kind + ' wc-capability-block-rl-col wc-capability-block-rl-' + kind + '" data-ds-block-item="' + escapeHtml(column.key) + '">' +
      '<div class="special-head wc-capability-block-rl-head">' +
        '<span>' + renderLucideIcon(icon, { class: 'wc-capability-block-rl-icon', size: 16 }) + escapeHtml(title) + '</span>' +
        '<span class="special-count wc-capability-block-rl-count">' + visibleItems.length + '</span>' +
      '</div>' +
      '<div class="special-body wc-capability-block-rl-list">' +
        visibleItems.map(function (item) {
          return renderSpecialBlockItem(item, labels)
        }).join('') +
      '</div>' +
    '</div>'
  )
}

function renderSpecialBlockItem(item, labels) {
  if (!isObject(item)) return '<div>' + escapeHtml(item) + '</div>'
  if (Object.prototype.hasOwnProperty.call(item, 'question') || Object.prototype.hasOwnProperty.call(item, 'suggestedWording')) {
    return renderClarificationItem(item)
  }
  var status = normalizeEvidenceStatus(item.evidenceStatus)
  var statusLabel = resolveEvidenceStatusLabel(status, labels)
  var statusHtml = statusLabel
    ? '<span class="wc-capability-block-sensitive-status" data-evidence-status="' + escapeHtml(status) + '">' + escapeHtml(statusLabel) + '</span>'
    : ''
  var basis = String(item.basis || item.justification || '').trim()
  var guidance = String(item.guidance || item.advice || item.application || '').trim()
  var missingInformation = String(item.missingInformation || '').trim()
  var body = [
    basis ? '<div class="wc-capability-block-sensitive-basis"><strong>' + escapeHtml(labels.basis) + '</strong> ' + escapeHtml(basis) + '</div>' : '',
    guidance ? '<div class="wc-capability-block-sensitive-guidance"><strong>' + escapeHtml(labels.guidance) + '</strong> ' + escapeHtml(guidance) + '</div>' : '',
    missingInformation ? '<div class="wc-capability-block-sensitive-missing"><strong>' + escapeHtml(labels.missingInformation) + '</strong> ' + escapeHtml(missingInformation) + '</div>' : ''
  ].join('')

  return (
    '<div class="wc-capability-block-sensitive-point">' +
      '<div class="wc-capability-block-sensitive-head">' +
        '<span class="wc-capability-block-sensitive-title">' + escapeHtml(item.label || labels.details) + '</span>' +
        statusHtml +
      '</div>' +
      body +
    '</div>'
  )
}

function renderClarificationItem(item) {
  var question = String(item.question || item.label || '').trim()
  var whyItMatters = String(item.whyItMatters || '').trim()
  var suggestedWording = String(item.suggestedWording || '').trim()
  if (!question) return ''

  return (
    '<div class="wc-capability-block-sensitive-point" data-clarification-item="true">' +
      '<div class="wc-capability-block-sensitive-head">' +
        '<span class="wc-capability-block-sensitive-title">' + escapeHtml(question) + '</span>' +
      '</div>' +
      (whyItMatters ? '<div class="wc-capability-block-sensitive-basis"><strong>Pourquoi :</strong> ' + escapeHtml(whyItMatters) + '</div>' : '') +
      (suggestedWording ? '<div class="wc-capability-block-sensitive-guidance"><strong>Formulation :</strong> ' + escapeHtml(suggestedWording) + '</div>' : '') +
    '</div>'
  )
}

function renderHandoffActions(block, labels) {
  return renderHandoffActionsSection(block.content, labels, block.title, { renderEmpty: true })
}

function renderHandoffActionsSection(actions, translations, title, options) {
  var labels = normalizeCapabilityBlockViewTranslations(translations)
  var normalizedActions = normalizeActions(actions)
  if (!normalizedActions.length && !(options && options.renderEmpty)) return ''
  var visibleActions = normalizedActions.length ? normalizedActions : [{ label: labels.noAction, targetCapability: 'NONE' }]
  return renderSection(title || labels.recommendedActions, '<div class="capability-suggestions wc-capability-block-actions-list" aria-label="' + escapeHtml(labels.recommendedActions) + '" data-ds-block="handoff-actions" data-block-type="handoff-actions">' + visibleActions.map(function (action) {
    var normalizedAction = normalizeAction(action)
    var disabled = normalizedAction.targetCapability === 'NONE' ? ' disabled' : ''
    var indexAttr = normalizedAction.index === null || normalizedAction.index === undefined
      ? ''
      : ' data-capability-action-index="' + escapeHtml(normalizedAction.index) + '"'
    var iconHtml = normalizedAction.icon
      ? renderLucideIcon(normalizedAction.icon, { size: 15 })
      : ''
    var handleHtml = normalizedAction.handle
      ? '<span class="capability-handle">' + escapeHtml(normalizedAction.handle) + '</span>'
      : ''
    return (
      '<button class="capability-action wc-capability-block-action-row" type="button"' + disabled + indexAttr + ' data-target-capability="' + escapeHtml(normalizedAction.targetCapability) + '">' +
        '<span class="capability-action-capability">' + iconHtml + handleHtml + '</span>' +
        '<span class="capability-action-label wc-capability-block-action-text">' + escapeHtml(normalizedAction.label) + '</span>' +
      '</button>'
    )
  }).join('') + '</div>', 'handoff-actions')
}

function renderHandoffActionsEmbed(actions, translations, title) {
  var section = renderHandoffActionsSection(actions, translations, title)
  if (!section) return ''
  return '<div class="wc-capability-block-ui wc-capability-block-actions-embed" data-ds-view="handoff-actions-embed">' + section + '</div>'
}

function bindHandoffActions(root, actions, handlers) {
  if (!root || !handlers || typeof handlers.onAction !== 'function') return

  var normalizedActions = normalizeActions(actions)
  root.querySelectorAll('[data-capability-action-index]').forEach(function (button) {
    button.addEventListener('click', function () {
      var index = Number(button.getAttribute('data-capability-action-index'))
      var action = normalizedActions[index]
      if (!action || !action.targetCapability || action.targetCapability === 'NONE') return
      handlers.onAction(action)
    })
  })
}

function renderEvidenceDetails(block, labels) {
  var details = normalizeColumns(block.columns)
    .map(function (column) {
      return {
        key: column.key,
        title: column.title || resolveColumnTitle(column.key, labels),
        content: column.content
      }
    })
    .filter(function (column) {
      return hasRenderableContent(column.content)
    })

  if (!details.length) return ''

  return (
    '<section class="summary-section wc-capability-block-section" data-ds-section="evidence-details">' +
      '<div class="section-kicker wc-capability-block-section-title">' + escapeHtml(block.title || labels.deepen) + '</div>' +
      '<details class="deep-card wc-capability-block-evidence" data-ds-block="evidence-details" data-block-type="evidence-details">' +
        '<summary>' + renderLucideIcon('chevron-right', { class: 'wc-capability-block-details-icon', size: 16 }) + escapeHtml(labels.evidenceToggle) + '</summary>' +
        '<div class="deep-body wc-capability-block-evidence-body">' +
          details.map(renderEvidenceBlock).join('') +
        '</div>' +
      '</details>' +
    '</section>'
  )
}

function renderEvidenceBlock(column) {
  var items = Array.isArray(column.content) ? column.content : [column.content]
  return (
    '<div class="wc-capability-block-evidence-block">' +
      '<div class="wc-capability-block-evidence-title">' + escapeHtml(column.title) + '</div>' +
      '<ul>' + items.map(function (item) {
        return '<li>' + escapeDisplayText(renderContentText(item)) + '</li>'
      }).join('') + '</ul>' +
    '</div>'
  )
}

function renderGenericBlock(block, labels) {
  if (!hasRenderableContent(block.content)) return ''
  return renderSection(block.title || labels.details, '<div class="summary-card wc-capability-block-summary-card" data-ds-block="summary-card" data-block-type="' + escapeHtml(block.type || 'generic') + '">' + escapeDisplayText(renderContentText(block.content)) + '</div>', String(block.type || 'generic'), block.key)
}

function renderSection(title, body, blockType, sectionKey) {
  if (!body) return ''
  var idAttr = sectionKey ? ' id="briefing-section-' + escapeHtml(sectionKey) + '"' : ''
  return (
    '<section class="summary-section wc-capability-block-section"' + idAttr + ' data-ds-section="' + escapeHtml(blockType || '') + '">' +
      '<div class="section-kicker wc-capability-block-section-title">' + escapeHtml(title) + '</div>' +
      body +
    '</section>'
  )
}

function renderNumberedRows(items) {
  return '<div class="numbered wc-capability-block-points-card" data-ds-block="numbered-list" data-block-type="numbered-list">' + (items || []).map(function (item, index) {
    var model = normalizeNumberedItem(item)
    return (
      '<div class="numbered-row wc-capability-block-point-row">' +
        '<span class="index wc-capability-block-point-index">' + formatIndex(index) + '</span>' +
        '<div class="numbered-text wc-capability-block-point-text">' + renderNumberedItemContent(model) + renderNumberedItemCitations(model.citations) + '</div>' +
      '</div>'
    )
  }).join('') + '</div>'
}

function renderNumberedItemContent(item) {
  var text = isObject(item) ? String(item.label || item.text || '').trim() : String(item || '').trim()
  var parsed = parseRecommendationText(text)
  if (!parsed) return escapeDisplayText(text)
  var details = [
    parsed.justification ? '<div class="wc-capability-block-point-detail"><strong>Justification</strong> ' + escapeHtml(parsed.justification) + '</div>' : '',
    parsed.application ? '<div class="wc-capability-block-point-detail"><strong>Application</strong> ' + escapeHtml(parsed.application) + '</div>' : '',
    parsed.missingInformation ? '<div class="wc-capability-block-point-detail"><strong>Information manquante</strong> ' + escapeHtml(parsed.missingInformation) + '</div>' : ''
  ].join('')
  return (
    '<div class="wc-capability-block-point-main">' + escapeHtml(parsed.label) + '</div>' +
    details
  )
}

function renderNumberedItemCitations(citations) {
  var normalized = normalizeCitations(citations)
  if (!normalized.length) return ''
  return (
    '<div class="wc-capability-block-citations">' +
      normalized.map(function (citation) {
        return (
          '<span class="wc-capability-block-citation" title="' + escapeHtml(citation.excerpt) + '">' +
            renderLucideIcon('bookOpen', { size: 14 }) +
            '<span class="wc-capability-block-citation-text">' + escapeHtml(citation.excerpt) + '</span>' +
          '</span>'
        )
      }).join('') +
    '</div>'
  )
}

function resolveReliabilityValue(block, blockViewUi) {
  var options = isObject(block.options) ? block.options : {}
  var binding = options.reliabilityBinding || 'confidence'
  return isObject(blockViewUi.summary) ? blockViewUi.summary[binding] : null
}

function normalizeConfidence(value, labels) {
  var normalized = String(value || '').toLowerCase()
  if (normalized === 'high') return { label: labels.confidenceHigh, percent: 90 }
  if (normalized === 'medium') return { label: labels.confidenceMedium, percent: 60 }
  if (normalized === 'low') return { label: labels.confidenceLow, percent: 30 }

  var numeric = Number(value)
  if (Number.isFinite(numeric)) {
    var percent = numeric <= 1 ? numeric * 100 : numeric
    return {
      label: labels.confidenceComputed,
      percent: Math.max(0, Math.min(100, Math.round(percent)))
    }
  }

  return { label: labels.confidenceLow, percent: 30 }
}

function normalizeColumns(value) {
  return Array.isArray(value)
    ? value.filter(isObject).map(function (column) {
      return {
        key: String(column.key || ''),
        title: column.title || '',
        content: column.content
      }
    })
    : []
}

function normalizeStringArray(value) {
  return Array.isArray(value)
    ? value.map(function (item) { return renderContentText(item).trim() }).filter(Boolean)
    : []
}

function normalizeNumberedItems(value) {
  return Array.isArray(value)
    ? value.map(normalizeNumberedItem).filter(function (item) { return item.label })
    : []
}

function normalizeNumberedItem(value) {
  if (!isObject(value)) {
    return {
      label: renderContentText(value).trim(),
      citations: []
    }
  }

  return {
    label: String(value.label || value.text || value.value || '').trim(),
    citations: normalizeCitations(value.citations)
  }
}

function normalizeCitations(value) {
  return Array.isArray(value)
    ? value.filter(isObject).map(function (citation) {
      return {
        sourceId: String(citation.sourceId || '').trim(),
        fragmentId: String(citation.fragmentId || '').trim(),
        categoryId: String(citation.categoryId || '').trim(),
        excerpt: String(citation.excerpt || citation.summary || '').trim(),
        summary: String(citation.summary || '').trim()
      }
    }).filter(function (citation) {
      return citation.sourceId && citation.excerpt
    }).slice(0, 2)
    : []
}

function normalizeTimelineModel(value, labels) {
  var content = isObject(value) ? value : {}
  var items = normalizeTimelineItems(isObject(value) ? content.items : value)
  return {
    summary: String(content.summary || buildTimelineSummary(items, labels)).trim(),
    filters: normalizeTimelineFilters(content.filters, items),
    items: items
  }
}

function normalizeTimelineFilters(value, items) {
  if (Array.isArray(value) && value.length) {
    return value.map(function (filter) {
      return {
        key: String(filter && filter.key || '').trim(),
        label: String(filter && filter.label || '').trim(),
        count: Number(filter && filter.count || 0)
      }
    }).filter(function (filter) { return filter.key && filter.label })
  }

  var counts = {}
  items.forEach(function (item) {
    counts[item.category] = counts[item.category] || { key: item.category, label: item.categoryLabel, count: 0 }
    counts[item.category].count += 1
  })
  var total = items.length
  return [{ key: 'all', label: 'Tout', count: total }].concat(Object.keys(counts).map(function (key) { return counts[key] }))
}

function buildTimelineSummary(items, labels) {
  if (!items.length) return labels.noRecentHistory
  var meaningfulItems = items.filter(function (item) { return item.id !== 'empty-timeline' })
  if (!meaningfulItems.length) return items[0].summary || labels.noRecentHistory
  var first = meaningfulItems[0]
  return meaningfulItems.length + ' activité' + (meaningfulItems.length > 1 ? 's' : '') + ' récente' + (meaningfulItems.length > 1 ? 's' : '') + ' retrouvée' + (meaningfulItems.length > 1 ? 's' : '') + '. Dernier élément: ' + (first.title || first.displayText) + '.'
}

function normalizeTimelineItems(value) {
  return Array.isArray(value)
    ? value.map(function (item, index) {
      if (isObject(item)) {
        var displayText = String(item.displayText || item.summary || item.title || '').trim()
        var category = normalizeTimelineCategory(item.category || item.type || item.source || displayText)
        if (!displayText) return null
        return {
          id: String(item.id || 'timeline-' + (index + 1)).trim(),
          date: String(item.date || '').trim(),
          title: String(item.title || displayText).trim(),
          summary: String(item.summary || displayText).trim(),
          source: String(item.source || '').trim(),
          type: String(item.type || '').trim(),
          category: category,
          categoryLabel: String(item.categoryLabel || labelTimelineCategory(category)).trim(),
          status: String(item.status || '').trim(),
          signal: String(item.signal || '').trim(),
          scoreReasons: Array.isArray(item.scoreReasons)
            ? item.scoreReasons.map(function (reason) { return String(reason || '').trim() }).filter(Boolean)
            : [],
          displayText: displayText
        }
      }

      var text = String(item || '').trim()
      if (!text) return null
      return {
        id: 'timeline-' + (index + 1),
        date: '',
        title: text,
        summary: text,
        source: '',
        type: '',
        category: 'suivi',
        categoryLabel: 'Suivi',
        status: '',
        signal: '',
        scoreReasons: [],
        displayText: text
      }
    }).filter(Boolean)
    : []
}

function normalizeTimelineCategory(value) {
  var text = normalizeDisplayText(value).toLowerCase()
  if (/document|devis|quote|proposal|proposition|contrat|contract|fichier|file|pdf|api|sage|securite|sécurité/.test(text)) return 'documents'
  if (/meeting|rendez|rdv|atelier|demo|démonstration|demonstration|call|appel|visio|reunion|réunion|echange|échange/.test(text)) return 'echanges'
  if (/mail|email|message|courriel|plume/.test(text)) return 'messages'
  return 'suivi'
}

function labelTimelineCategory(value) {
  var labels = {
    documents: 'Documents',
    suivi: 'Suivi',
    echanges: 'Échanges',
    messages: 'Messages'
  }
  return labels[value] || 'Suivi'
}

function normalizeSpecialBlockItems(value) {
  return Array.isArray(value)
    ? value.map(function (item) {
      if (isObject(item)) return item
      return parseSensitivePointText(renderContentText(item).trim())
    }).filter(function (item) {
      return isObject(item) || Boolean(item)
    })
    : []
}

function parseSensitivePointText(value) {
  var text = normalizeDisplayText(value)
  if (!text) return ''
  var parsed = {
    label: text,
    evidenceStatus: '',
    basis: '',
    guidance: '',
    missingInformation: ''
  }
  var baseMatch = text.match(/\bBase\s*:\s*/i)
  if (!baseMatch || baseMatch.index === undefined) return text

  var head = text.slice(0, baseMatch.index).replace(/[—.-]\s*$/, '').trim()
  var body = text.slice(baseMatch.index + baseMatch[0].length).trim()
  var guidanceMatch = body.match(/\bConduite\s*:\s*/i)
  if (guidanceMatch && guidanceMatch.index !== undefined) {
    parsed.basis = body.slice(0, guidanceMatch.index).trim()
    body = body.slice(guidanceMatch.index + guidanceMatch[0].length).trim()
  } else {
    parsed.basis = body
    body = ''
  }

  var missingMatch = body.match(/\bInformations?\s+manquantes?\s*/i)
  if (missingMatch && missingMatch.index !== undefined) {
    parsed.guidance = body.slice(0, missingMatch.index).trim()
    parsed.missingInformation = body.slice(missingMatch.index + missingMatch[0].length).replace(/^[:.-]\s*/, '').trim()
  } else {
    parsed.guidance = body
  }

  var statusMatch = head.match(/(Informations?\s+manquantes?|Information\s+manquante|Probable|Observ[ée])$/i)
  if (statusMatch) {
    parsed.evidenceStatus = normalizeEvidenceStatusLabel(statusMatch[1])
    parsed.label = head.slice(0, statusMatch.index).replace(/[—.-]\s*$/, '').trim()
  } else {
    parsed.label = head
  }

  return parsed.label ? parsed : text
}

function parseRecommendationText(value) {
  var text = normalizeDisplayText(value)
  var justificationMatch = text.match(/\bJustification\s*:\s*/i)
  var applicationMatch = text.match(/\bApplication\s*:\s*/i)
  if (!justificationMatch || justificationMatch.index === undefined || !applicationMatch || applicationMatch.index === undefined) return null

  var missingMatch = text.match(/\bInformation\s+manquante\s*:\s*/i)
  var label = text.slice(0, justificationMatch.index).replace(/[—:-]\s*$/, '').trim()
  var justification = text.slice(
    justificationMatch.index + justificationMatch[0].length,
    applicationMatch.index
  ).trim()
  var applicationEnd = missingMatch && missingMatch.index !== undefined ? missingMatch.index : text.length
  var application = text.slice(applicationMatch.index + applicationMatch[0].length, applicationEnd).trim()
  var missingInformation = missingMatch && missingMatch.index !== undefined
    ? text.slice(missingMatch.index + missingMatch[0].length).replace(/\.$/, '').trim()
    : ''

  if (!label) return null
  return { label: label, justification: justification, application: application, missingInformation: missingInformation }
}

function normalizeActions(value) {
  return Array.isArray(value)
    ? value.map(function (item, index) {
      var action = normalizeAction(item)
      action.index = Number.isInteger(action.index) ? action.index : index
      return action
    }).filter(function (action) { return action.label })
    : []
}

function normalizeAction(value) {
  if (isObject(value)) {
    var label = String(value.label || value.title || value.action || '').trim()
    var rawTargetCapability = value.targetCapability || value.capability || value.target || value.suggestedCapability
    var targetCapability = rawTargetCapability
      ? normalizeTargetCapability(rawTargetCapability)
      : inferTargetCapability(label)
    return {
      label: label,
      targetCapability: targetCapability,
      index: value.index,
      reason: String(value.reason || '').trim(),
      handle: String(value.displayLabel || value.handle || '').trim() || resolveCapabilityHandle(targetCapability),
      icon: String(value.icon || '').trim() || resolveCapabilityIcon(targetCapability),
      displayLabel: String(value.displayLabel || '').trim(),
      proposalId: value.proposalId || null,
      requestContext: isObject(value.requestContext) ? value.requestContext : {}
    }
  }

  var text = String(value || '').trim()
  var inferredTarget = inferTargetCapability(text)
  return {
    label: text,
    targetCapability: inferredTarget,
    reason: '',
    handle: resolveCapabilityHandle(inferredTarget),
    icon: resolveCapabilityIcon(inferredTarget),
    displayLabel: '',
    requestContext: {}
  }
}

function normalizeCapabilityActions(blockViewUi) {
  var blocks = Array.isArray(blockViewUi && blockViewUi.blocks) ? blockViewUi.blocks : []
  var output = []
  blocks.forEach(function (block) {
    if (String(block && block.type || '').toLowerCase() !== 'handoff-actions') return
    normalizeActions(block.content).forEach(function (action) {
      output[action.index] = action
    })
  })
  return output
}

function normalizeTargetCapability(value) {
  var normalized = String(value || '').trim().toUpperCase()
  if (!normalized || normalized === 'NONE') return 'NONE'
  return normalized
}

function inferTargetCapability(label) {
  return String(label || '').trim() ? 'DICTATION' : 'NONE'
}

function resolveCapabilityHandle(targetCapability) {
  if (targetCapability === 'WRITE_EMAIL') return '@Plume'
  if (targetCapability === 'DICTATION') return '@Dictée'
  return ''
}

function resolveCapabilityIcon(targetCapability) {
  if (targetCapability === 'WRITE_EMAIL') return 'feather'
  if (targetCapability === 'DICTATION') return 'mic'
  return ''
}

function hasRenderableContent(value) {
  if (Array.isArray(value)) return value.length > 0
  if (isObject(value)) return Object.keys(value).length > 0
  return String(value || '').trim().length > 0
}

function renderContentText(value) {
  if (value == null) return ''
  if (typeof value === 'string') return value
  if (typeof value === 'number' || typeof value === 'boolean') return String(value)
  if (isObject(value)) {
    if (value.title && Array.isArray(value.items)) return value.title + ' - ' + value.items.join(', ')
    if (value.text) return String(value.text)
    if (value.summary) return String(value.summary)
    if (value.label) return String(value.label)
  }
  return JSON.stringify(value)
}

function resolveSummaryTitle(summary) {
  return summary && summary.summary && summary.summary.title ? summary.summary.title : ''
}

function resolveColumnTitle(key, labels) {
  if (key === 'risks') return labels.risks
  if (key === 'opportunities') return labels.opportunities
  if (key === 'nextActions') return labels.recommendedActions
  if (key === 'missingInformation') return labels.missingInformation
  if (key === 'evidence') return labels.evidence
  return key || labels.details
}

function resolveSpecialBlockKind(key) {
  if (key === 'risks') return 'warning'
  if (key === 'opportunities') return 'info'
  if (key === 'missingInformation') return 'danger'
  return 'info'
}

function resolveSpecialBlockIcon(key) {
  if (key === 'risks') return 'triangle-alert'
  if (key === 'opportunities') return 'trending-up'
  if (key === 'missingInformation') return 'shield-alert'
  return 'badge-info'
}

function normalizeEvidenceStatus(value) {
  var normalized = String(value || '').trim().toLowerCase()
  if (normalized === 'observed' || normalized === 'probable' || normalized === 'missing_information') return normalized
  return ''
}

function normalizeEvidenceStatusLabel(value) {
  var normalized = normalizeDisplayText(value).toLowerCase()
  if (/^probable$/.test(normalized)) return 'probable'
  if (/^observ/.test(normalized)) return 'observed'
  if (/information/.test(normalized) && /manquante/.test(normalized)) return 'missing_information'
  return ''
}

function resolveEvidenceStatusLabel(status, labels) {
  if (status === 'observed') return labels.observed
  if (status === 'probable') return labels.probable
  if (status === 'missing_information') return labels.missingInformation
  return ''
}

function normalizeIconName(value) {
  return String(value || '').trim()
}

function formatTimelineDate(value) {
  if (!value) return ''
  var date = new Date(value)
  if (Number.isNaN(date.getTime())) return String(value || '').trim()
  try {
    return date.toLocaleString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    })
  } catch (error) {
    return date.toISOString()
  }
}

function resolveTimelineIcon(item) {
  var type = String(item && item.type || '').toLowerCase()
  if (/mail|email/.test(type)) return 'mail'
  if (/call|phone|appel/.test(type)) return 'phone-call'
  if (/document|quote|devis|file/.test(type)) return 'file-text'
  if (/meeting|rendez|rdv|calendar/.test(type)) return 'calendar-check-2'
  return 'history'
}

function formatIndex(index) {
  return String(index + 1).padStart(2, '0')
}

function capitalize(value) {
  var text = String(value || '')
  return text ? text.charAt(0).toUpperCase() + text.slice(1) : text
}

function isObject(value) {
  return !!value && typeof value === 'object' && !Array.isArray(value)
}

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

function escapeDisplayText(value) {
  return escapeHtml(normalizeDisplayText(value)).replace(/\r?\n/g, '<br>')
}

function escapeTimelineText(value) {
  return escapeHtml(normalizeDisplayText(value)).replace(/\r?\n/g, '<br>')
}

function normalizeDisplayText(value) {
  return stripHtmlTags(decodeHtmlEntities(String(value || '')))
    .replace(/\u00a0/g, ' ')
    .replace(/[ \t]+\n/g, '\n')
    .replace(/\n[ \t]+/g, '\n')
    .replace(/[ \t]{2,}/g, ' ')
    .replace(/\n{3,}/g, '\n\n')
    .trim()
}

function stripHtmlTags(value) {
  return value
    .replace(/<\s*(script|style)(?:\s[^>]*)?>[\s\S]*?<\s*\/\s*\1\s*>/gi, '')
    .replace(/<\s*br\s*\/?\s*>/gi, '\n')
    .replace(/<\s*\/\s*(p|div|li|tr|h[1-6])\s*>/gi, '\n')
    .replace(/<\s*(p|div|li|tr|h[1-6])(?:\s[^>]*)?>/gi, '')
    .replace(/<\s*\/?\s*[a-z][a-z0-9-]*(?:\s[^>]*)?>/gi, '')
}

function decodeHtmlEntities(value) {
  var named = {
    amp: '&',
    apos: "'",
    gt: '>',
    lt: '<',
    nbsp: ' ',
    quot: '"'
  }

  return value.replace(/&(#x?[0-9a-f]+|[a-z]+);/gi, function (match, entity) {
    var key = String(entity || '').toLowerCase()
    if (Object.prototype.hasOwnProperty.call(named, key)) return named[key]
    if (key.charAt(0) === '#') {
      var isHex = key.charAt(1) === 'x'
      var rawCode = isHex ? key.slice(2) : key.slice(1)
      var code = parseInt(rawCode, isHex ? 16 : 10)
      if (Number.isFinite(code)) {
        try {
          return String.fromCodePoint(code)
        } catch (error) {
          return match
        }
      }
    }
    return match
  })
}

function normalizeCapabilityBlockViewTranslations(translations) {
  var fallback = {
    confidenceHigh: 'élevée',
    confidenceMedium: 'moyenne',
    confidenceLow: 'faible',
    confidenceComputed: 'calculée',
    aiSynthesis: 'Synthèse IA',
    briefingIntroTitle: 'L’essentiel en 30 secondes',
    createAction: 'Créer',
    basis: 'Base:',
    defaultCapabilityTitle: '@Agent',
    deepen: 'Pour approfondir',
    details: 'Détails',
    evidence: 'Preuves',
    evidenceToggle: 'Voir les faits ayant conduit à l’analyse',
    exchangeTimeline: 'Chronologie des échanges',
    exchangeTimelineHint: 'Chaque activité est résumée à partir des notes, commentaires ou échanges associés.',
    exploreBriefing: 'Explorer le briefing',
    exitObjective: 'Objectif de sortie',
    filterHistory: 'Filtrer l’historique',
    executiveSummary: 'Résumé exécutif',
    keyTakeaways: 'Ce qu’il faut retenir',
    keyPoints: 'Points clés',
    missingInformation: 'Informations manquantes',
    noAction: 'Aucune action recommandée disponible.',
    noRecentHistory: 'Aucun changement significatif n’a été détecté depuis le dernier échange connu.',
    noOpportunity: 'Aucune opportunité spécifique identifiée dans les données disponibles.',
    noRisk: 'Aucun risque identifié dans les données disponibles.',
    noSummary: 'Résumé non disponible.',
    observed: 'Observé',
    opportunities: 'Opportunités',
    probable: 'Probable',
    guidance: 'Conduite:',
    generatedAt: 'Généré le',
    recentHistory: 'Historique récent',
    recommendedActions: 'Actions recommandées',
    refreshBriefing: 'Recalculer le briefing',
    refreshDebrief: 'Rafraîchir le bilan',
    reliability: 'Fiabilité',
    risks: 'Risques',
    risksAndOpportunities: 'Risques et opportunités',
    signal: 'Signal:'
  }

  return Object.assign({}, fallback, translations || {})
}

export {
  bindCapabilityBlockViewUi,
  bindHandoffActions,
  normalizeActions as normalizeHandoffActions,
  normalizeCapabilityBlockViewUi,
  renderCapabilityBlockViewUi,
  renderHandoffActionsEmbed,
  renderHandoffActionsSection
}
